<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEmpty from '../../../../app/components/list/ListEmpty.vue'
  import ReviewStatusLabel from './labels/ReviewStatusLabel'
  import * as restfulService from '../../../services/restfulService'
  import DataService from '../../../services/dataService'
  import helperMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'
  import {clone} from 'lodash'

  const defaultFilters = {event_id: '', dates: []}

  export default {
    components: {ListHeader, ListEmpty, ReviewStatusLabel},
    mixins: [helperMixin],
    data () {
      return {
        isLoadingData: true,
        filters: clone(defaultFilters),
        list: [],
        dependencies: {
          main_events: []
        },
        paper: {}
      }
    },
    computed: {
      emptyList: function () {
        return this.list.length === 0
      }
    },
    mounted () {
      this.getDependencies().then(() => {
        this.loadEvaluations()
      })
    },
    methods: {
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([{domain: 'main_event'}]).then((result) => {
            this.dependencies = result
            resolve()
          })
        })
      },
      loadEvaluations () {
        bus.$emit('show-loader')
        const statusName = this.$route.params.status || null
        let data = this.getSearchData()
        restfulService.post('evaluation', statusName, null, data)
          .then((response) => {
            this.list = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isLoadingData = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      getSearchData () {
        const searchData = {}
        if (this.filters.event_id) {
          searchData.event_id = this.filters.event_id
        }
        if (this.filters.dates && this.filters.dates.length > 0) {
          let startDate = this.dateFormat(this.filters.dates[0], 'en')
          let endDate = this.dateFormat(this.filters.dates[1], 'en')
          if (startDate.length > 0 && endDate.length > 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          } else if (startDate.length > 0 && endDate.length === 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = startDate + ' 23:59:59'
          } else if (startDate.length === 0 && endDate.length > 0) {
            searchData.start_date = endDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          }
        }
        return searchData
      },
      onFilter () {
        this.loadEvaluations()
      },
      onFilterClean () {
        this.filters = clone(defaultFilters)
        this.loadEvaluations()
      }
    }
  }
</script>

<template>
    <div class="custom-list">
        <h2>Avaliações</h2>
        <h4 class="header-subtitle">Avaliações que foram atribuidas a você</h4>

        <el-card class="el-card__search_list box-card submissions-search-box">
            <div slot="header">
                <span>Filtrar Avaliações</span>
                <div class="el-search-buttons">
                    <el-button type="primary" size="small" @click="onFilter">
                        <i class="fa fa-filter"></i>
                        <span>Aplicar Filtro</span>
                    </el-button>
                    <el-button type="default" size="small" @click="onFilterClean">Limpar</el-button>
                </div>
            </div>
            <el-form :inline="true" :model="filters" class="demo-form-inline">
                <div>
                    <el-form-item label="Evento Principal">
                        <el-select v-model="filters.event_id"
                                   filterable
                                   clearable
                                   placeholder="Filtrar Evento"
                                   empty-text="Nenhum registro encontrado">
                            <el-option v-for="item in dependencies.main_events"
                                       :key="item.id"
                                       :label="item.title"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>

        <div class="responsive-table">
            <table class="custom-table-list" v-if="!emptyList">
                <thead>
                <tr>
                    <th>Cód. Trabalho</th>
                    <th>Evento</th>
                    <th>Tipo de Avaliação</th>
                    <th>Prazo Final</th>
                    <th>Última Atualização</th>
                    <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in list">
                    <td>{{item.paper_id}}</td>
                    <td>
                        <div><strong>{{item.main_event}}</strong></div>
                        <div> - {{item.event}}</div>
                    </td>
                    <td>{{item.evaluation_type}}</td>
                    <td>{{item.end_datetime | dateTimeEnToBr}}</td>
                    <td>
                        <div v-if="item.evaluation_opened || item.evaluated">
                            <review-status-label :status-id="item.status.id"
                                                 :status-key="item.status.key"
                                                 :status-name="item.status.name"/>
                        </div>
                        <el-tag v-if="!item.evaluation_opened && !item.evaluated" type="danger">Prazo de Avaliação Finalizado</el-tag>
                        <div class="small">Última Atualização: {{item.last_modified | dateTimeEnToBr }}</div>
                    </td>
                    <td>
                        <router-link :to="{ name: 'evaluation.show', params: { id: item.id } }"
                                     class="el-button el-button--info el-button--small"
                                     title="Visualizar">
                            <i class="fa fa-eye"></i>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <list-empty v-if="emptyList" description="Nenhuma avaliação encontrada, verifique os filtros e tente novamente"/>
    </div>
</template>
